import React, { useState, useEffect } from "react";
import Caraousel from "./Caraousel";
import ImageUpload from "./ImageUpload";

import pre1 from "../../../assets/wedding/images/ceremony1.jpg";
import pre2 from "../../../assets/wedding/images/ceremony2.jpg";
import pre3 from "../../../assets/wedding/images/ceremony3.jpg";
import pre4 from "../../../assets/wedding/images/ceremony4.jpg";
import civil from "../../../assets/wedding/images/civil.jpg";
import reception from "../../../assets/wedding/images/reception.jpg";
import wedding from "../../../assets/wedding/images/wedding.jpg";


const Gallery = ({details, onChange}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(-1);
  const [galleryImages, setGalleryImages] = useState([]);
  const [showLimit, setShowLimit] = useState(8);

  const imgs = [pre1,pre2,pre3,pre4,civil,reception,wedding];

  const openModal = (index) => {
    console.log("openModal", index);
    setSelectedImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImageIndex(-1);
  };

  const addImage = () => {
    const newIdx = galleryImages.reduce((a,v)=>Math.max(a, v.idx), 0) + 1;
    console.log("newIdx", newIdx, galleryImages);
    setGalleryImages([...galleryImages, {idx:newIdx, url:imgs[Math.floor(Math.random()*1e10) % imgs.length]}]);
  };

  useEffect(()=>{
    if (Array.isArray(details?.images)) {
      const newGalleryImages=[];
      details.images.forEach(img => {
        if (img.name.substring(0,8)==="gallery_") {
          const idx = parseInt(img.name.substring(8), 10) || 0;
          newGalleryImages.push({idx:idx, url:img.url});
        }
      });
      newGalleryImages.sort(function(a,b) {
        return a.idx-b.idx;
      });
      setGalleryImages(newGalleryImages);
    }
  },[details]);



  if (!details.owner && galleryImages.length===0) {
    return <>
    <div style={{height:"70px"}}></div>
    </>;
  }

  return (
    <>
      <div id="gallery">
        <section className="web-inner-page our-gallery">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="web-top-title">Our Gallery</div>
                {details.owner && <div className="text-center">
                Add photos of you both to add to your wedding website for all your guests to view.
                </div>}
              </div>
            </div>
            <div className="row">
              {galleryImages.slice(0, showLimit).map((image, i) => (
                <div key={image.url} className="col-lg-3 col-md-6 g-img">
                  <ImageUpload
                    canEdit={details.owner}
                    onChange={onChange}
                    onNonEditClick={()=>openModal(i)}
                    canDelete
                    defaultImage={image.url}
                    imageName={"gallery_"+image.idx}
                    imageClass="d-block w-100"
                    alt="gallery image"
                  />
                </div>
              ))}
              <div className="clearfix"></div>
                {details.owner && 
                  <div className="col-md-12 web-img-btn my-3">
                    <a onClick={addImage}>Add a picture</a>
                    <div className="clearfix"></div>
                  </div>
                }
              { (galleryImages.length>showLimit) &&
                <div className="col-md-12 web-img-btn">
                  <a onClick={()=>setShowLimit(showLimit+8)}>More Photographs </a>
                  <div className="clearfix"></div>
                </div>
              }
            </div>
          </div>
        </section>

        {/* <!-- Modal --> */}
        <div
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog custom-modal-dialog">
            <div className="modal-content ">
              <div className="modal-header">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={closeModal}
                >
                  X
                </button>
              </div>

              <div className="modal-body">
                <Caraousel
                  selected={selectedImageIndex}
                  galleryArray={galleryImages}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
